<template>
  <div>
    <el-page-header class="detail-head" @back="goBack" content="微信消息详情"> </el-page-header>
    <el-divider></el-divider>
    <div class="detail-container">
      <el-scrollbar>
        <el-form class="detail-form" ref="mainForm" :model="entity" label-width="100px">
      <el-row :gutter="20">
        <el-col :span="6">
          <div class="grid-content">
            <el-form-item label="标题" class="detail-form-item">
              <el-input size="medium" v-model="entity.title" readonly></el-input>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content">
            <el-form-item label="类型" class="detail-form-item">
              <el-input size="medium" v-model="entity.type" readonly></el-input>
            </el-form-item>
          </div>
        </el-col>
         <el-col :span="6">
          <div class="grid-content">
            <el-form-item label="用户名称" class="detail-form-item">
              <el-input size="medium" v-model="entity.name" readonly></el-input>
            </el-form-item>
          </div>
        </el-col>
         <el-col :span="6">
          <div class="grid-content">
            <el-form-item label="发送时间" class="detail-form-item">
              <el-input size="medium" v-model="entity.createTime" readonly></el-input>
            </el-form-item>
          </div>
        </el-col> 
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <div class="grid-content">
            <el-form-item label="发送内容" class="detail-form-item">
              <el-input type="textarea" rows="5" v-model="entity.content"></el-input>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6">
          <div class="grid-content">
            <el-form-item label="创建人" class="detail-form-item">
              <el-input size="medium" v-model="entity.creator" disabled></el-input>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content">
            <el-form-item label="创建时间" class="detail-form-item">
              <el-input size="medium" v-model="entity.createTime" disabled></el-input>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content">
            <el-form-item label="修改人" class="detail-form-item">
              <el-input size="medium" v-model="entity.modifier" disabled></el-input>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content">
            <el-form-item label="修改时间" class="detail-form-item">
              <el-input size="medium" v-model="entity.modifyTime" disabled></el-input>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <div class="grid-content">
            <el-form-item label="备注" class="detail-form-item">
              <el-input type="textarea" v-model="entity.remark"></el-input>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
       </el-form>
      </el-scrollbar>
    </div>
    <el-divider class="detail-divider"></el-divider>
    <div class="detail-form-item-btns">
      <el-button v-if="edit" size="medium" class="detail-form-item-btn" type="primary" @click="save">保存</el-button>
      <el-button size="medium" class="detail-form-item-btn" @click="goBack">返回列表</el-button>
      <el-button size="medium" class="detail-form-item-btn" @click="reset">刷新</el-button>
    </div>
  </div>
</template>

<script lang="ts">
import { Options } from "vue-class-component";
import { BaseDetail } from "@/script/core/view/BaseDetail";
import { Message } from "@/script/apps/wechat/entity/WechatEntity";
import { ServiceContext, ServiceFactory } from "@/script/core/base/ServiceData";
import { DictUtil } from "@/script/core/Dict";
import { MessageService } from "@/script/apps/wechat/service/MessageService";
import { ElMessage } from "element-plus";

@Options({})
export default class MessageDetail extends BaseDetail {
  

  private service = new MessageService();

  public initData(): ServiceContext {
    return ServiceFactory.build(
      "biz_wechat_message",
      "/wechat/message",
      "/wechat/message",
      this.service
    );
  } 

  public newEntity() {
    const entity: Message = {};
    return entity;
  }

  
}
</script>

<style lang="scss">

</style>
